//#region Libraries
import {
    useState } from "react";
//#endregion
//#region Styles
import {
    Container, 
    Content, 
    Subcontent, 
    ContainerTextInput, 
    CharCounter, 
    ShowPassword } from "./styles";
import { 
    BottomPart, HelperText, 
    RequiredAsterisk, Row } from "components/styles";
//#endregion
//#region Components
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
//#endregion

const CustomTextInput = ({
    className, placeholder, label, 
    value, onChange, variant = "primary",
    helperText, disabled = false, 
    maxLength, showCounter = false,
    iconAdornment, error = false, 
    errorText, multiline = true, 
    minWidth, tooltipButton,
    width, required,
    ...restProps
}) => {
    //#region States
    const [focusInput, setFocusInput] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    //#endregion
    //#region Effects
    //#endregion
    //#region Functions
    const getClassNameError = () => {
        return error ? "error" : "";
    }
    const getClassNameContainerTextInput = () => {
        const classList = [];
        classList.push(variant);
        className && classList.push(className);
        error && classList.push("error");
        disabled && classList.push("disabled");
        return classList.join(" ");
    }
    const isPasswordInput = () => restProps?.type === "password";
    const getInputType = () => isPasswordInput() ? (showPassword ? "text" : "password") : "text";
    //#endregion
    return (
        <Container minWidth={minWidth} width={width} data-field="text">
            <Content className={disabled ? "disabled" : ""}>
                <Subcontent>
                    {label && 
                    <Row width="max-content" gap="3px">
                        <label>
                            {label} 
                            {" "}
                            {(required && !disabled) && 
                            <RequiredAsterisk>*</RequiredAsterisk>}
                        </label>
                        {tooltipButton}
                    </Row>}
                    <ContainerTextInput
                        className={getClassNameContainerTextInput()}
                        focusInput={focusInput}
                        width={width}
                        tabIndex="0">
                        {(multiline && disabled)
                            ?
                                <div data-role="disabled-input">
                                    <span data-role="text">
                                        {value ? value : placeholder}
                                    </span>
                                </div>
                            : <input 
                                {...restProps}
                                type={getInputType()}
                                disabled={disabled} 
                                onChange={({ target }) => onChange && onChange(target.value)}
                                value={value}
                                onFocus={() => {
                                    setFocusInput(true);
                                    if ("onFocus" in restProps)
                                        restProps.onFocus();
                                }}
                                onBlur={() => {
                                    setFocusInput(false);
                                    if ("onBlur" in restProps)
                                        restProps.onBlur();
                                }}
                                placeholder={placeholder}
                                maxLength={maxLength}/>}
                        {iconAdornment && <div className="icon">{iconAdornment}</div>}
                        {isPasswordInput() 
                        ? <ShowPassword 
                            textDecoration={showPassword ? "line-through" : "unset"}
                            onClick={() => setShowPassword(!showPassword)}>
                            Mostrar
                        </ShowPassword> 
                        : null}
                    </ContainerTextInput>
                    {(error || (showCounter && maxLength)) && (
                    <BottomPart className={getClassNameError()}>
                        <ErrorMessage 
                            error={error}
                            text={errorText}/>
                        {(showCounter && maxLength) && 
                            <CharCounter className={getClassNameError()}>
                                {value.length} / {maxLength}
                            </CharCounter>}
                    </BottomPart>)}
                </Subcontent>
                {helperText && <HelperText>{helperText}</HelperText>}
            </Content>
        </Container>
    );
}

export default CustomTextInput;